// extracted by mini-css-extract-plugin
export default {"link":"zL-z","disabled":"AL-z"};